/**
 * 주간업무보고 — 보기(진입점) (/adm/project/weekly)
 * ($j.Pages.Admin.ProjectReport / body data-page-name="ProjectReport")
 *
 * 주차를 골라 서버가 그린 보고서 HTML 을 보여주고, 확정/해제와 프린트(새 창에 온전한 보고서 문서)를 한다.
 */
export default class ProjectReport {
    initialize() { initialize(); }
}

let rpNum = 0, rpHtml = '', rpLabel = '';

function initialize() {
    $('#rpWeek').on('change', () => rpLoad(parseInt($('#rpWeek').val())));
    $('#rpConfirm').on('click', rpToggleFixed);
    $('#rpPrint').on('click', openReportWindow);   // 바로 인쇄가 아니라 온전한 보고서 화면을 연다
    rpLoad();
}

function rpLoad(num) {
    $.post('/adm/ajax/project/weekly/report', { num: num || rpNum || '' }, function (res) {
        if (!res.result) return $j.Common.Util.swalert(res.message || '불러오지 못했습니다.');

        if (!res.report) {
            $('#rpWeek').html('<option value="">주차 없음</option>');
            $('#rpBox').html('<div class="text-muted">작성된 주차가 없습니다. <code>jbbuller_ops 의 ./weekly/weekly.sh --auto</code> 를 실행하세요.</div>');
            $('#rpConfirm, #rpPrint').prop('disabled', true);
            return;
        }

        rpNum = parseInt(res.report.num);

        $('#rpWeek').html((res.weeks || []).map(w =>
            `<option value="${w.num}" ${parseInt(w.num) === rpNum ? 'selected' : ''}>${w.wr_start} ~ ${w.wr_end} · ${w.wr_status}</option>`).join(''));

        const badge = { '초안': 'secondary', '편집중': 'info', '확정': 'success' }[res.report.wr_status] || 'secondary';
        $('#rpStatus').html(`<span class="badge badge-${badge}">${res.report.wr_status}</span>`);

        const meta = [];
        if (res.report.wr_generated_at) meta.push(`초안 생성 ${res.report.wr_generated_at}`);
        if (res.report.wr_confirmed_at) meta.push(`확정 ${res.report.wr_confirmed_at}`);
        $('#rpMeta').text(meta.join(' · '));

        $('#rpConfirm, #rpPrint').prop('disabled', false);
        $('#rpConfirm').text(res.report.wr_status === '확정' ? '확정 해제' : '확정')
                       .toggleClass('btn-primary', res.report.wr_status !== '확정')
                       .toggleClass('btn-default', res.report.wr_status === '확정');
        $('#rpBox').html(res.html);
        // 마스터플랜 캘린더는 자리만 와 있다 — 앞뒤 달로 넘겨 봐야 해서 브라우저가 그린다
        $('#rpBox .rp-mpcal').each((_, el) => $j.F.Admin.MasterCalendar.mount(el, { ...$(el).data('mpc'), readonly: true, colorBy: 'project' }));
        rpHtml  = res.html;
        rpLabel = `${res.report.wr_start} ~ ${res.report.wr_end}`;
    });
}

/* 프린트 — 새 창에 온전한 보고서 화면을 띄운다(대표 배포용). 인쇄는 그 안에서 한다.
   캘린더는 지금 화면에 그려진 달 그대로 옮긴다 — 새 창엔 스크립트가 없어 달 이동 버튼은 감춘다. */
function openReportWindow() {
    if (!rpHtml) return $j.Common.Util.swalert('보고서가 아직 준비되지 않았습니다.');
    const drawn = $('#rpBox').html();
    const win = window.open('', '_blank', 'width=1000,height=1200');
    if (!win) return $j.Common.Util.swalert('팝업이 차단되었습니다. 이 사이트의 팝업을 허용해 주세요.');
    win.document.open();
    win.document.write(reportDocHtml(drawn, rpLabel));
    win.document.close();
    win.focus();
}

// 새 창에 쓰는 독립 문서 — 관리자 CSS·JS 가 닿지 않으므로 스타일과 닫기/인쇄 버튼을 문서 안에 둔다
// (.ai/frontend.md 인라인 예외 4 — 브라우저 화면 밖으로 내보내는 출력물)
function reportDocHtml(inner, label) {
    return `<!doctype html><html lang="ko"><head><meta charset="utf-8">
<title>주간업무보고서 ${label || ''}</title>
<style>
  *{box-sizing:border-box}
  /* 새 창이라 관리자 CSS(토큰)가 없다 — 쓰는 토큰을 라이트 값으로 직접 둔다.
     종이(.rw-page)는 출력물이라 토큰과 무관하게 흰색으로 고정한다 — 점 텍스처는 바깥 여백에만. */
  :root{--adm-surface:#fff;--adm-surface-raised:#eef2f7;--adm-radius-xs:.2rem;--adm-radius-md:.25rem}
  body{margin:0;background:var(--adm-surface-raised);background-image:radial-gradient(#dbe1e9 1.1px,transparent 1.1px);background-size:16px 16px;
       font-family:'Malgun Gothic','Apple SD Gothic Neo','Noto Sans KR',sans-serif;color:var(--adm-c-2b2f36, #2b2f36)}
  .rw-tb{position:sticky;top:0;display:flex;justify-content:flex-end;gap:8px;padding:10px 16px;background:rgba(255,255,255,.92);border-bottom:1px solid #e3e6ea}
  .rw-tb button{border:1px solid #ccc;background:var(--adm-surface);border-radius:var(--adm-radius-xs);padding:6px 18px;font-size:13px;cursor:pointer}
  .rw-tb .p{background:#4472C4;color:#fff;border-color:#3562a8}
  .rw-page{max-width:900px;margin:30px auto;background:#fff;border:1px solid #e0e4ea;border-top:5px solid #4472C4;border-radius:var(--adm-radius-xs);
           box-shadow:0 10px 30px rgba(30,45,70,.14);padding:48px 56px;line-height:1.9;font-size:14.5px}
  .rw-page>*:first-child{margin-top:0}
  .rw-page h1{font-size:24px;font-weight:800;margin:0 0 6px;color:var(--adm-c-1a1d22, #1a1d22);letter-spacing:-.3px}
  .rw-page h2{font-size:17px;font-weight:700;margin:34px 0 12px;padding:0 0 8px 12px;border-left:4px solid #4472C4;border-bottom:1px solid #e9ecef;color:var(--adm-c-1b3a6b, #1b3a6b)}
  .rw-page h3{font-size:14.5px;font-weight:700;margin:22px 0 8px}
  .rw-page p{margin:0 0 10px}
  .rw-page ul{margin:4px 0 14px;padding-left:22px}.rw-page li{margin-bottom:5px}
  .rw-page hr{border:0;border-top:1px solid #eef0f3;margin:24px 0}
  .rw-page code{background:var(--adm-b-f2f4f7, #f2f4f7);color:var(--adm-c-b5384a, #b5384a);padding:1px 5px;border-radius:var(--adm-radius-xs)}
  .rw-page table{width:100%;border-collapse:collapse;margin:12px 0 20px;font-size:13px}
  .rw-page th{background:#4472C4;color:#fff;text-align:left;padding:9px 12px;border:1px solid #3562a8}
  .rw-page td{padding:8px 12px;border:1px solid #e0e5ec;vertical-align:top}
  .rw-page tbody tr:nth-child(even){background:var(--adm-b-f7f9fc, #f7f9fc)}
  .ob{display:inline-block;font-size:12.5px;font-weight:600;padding:2px 10px;border-radius:var(--adm-radius-md);margin:0 3px 2px 0;-webkit-print-color-adjust:exact;print-color-adjust:exact}
  ${$j.F.Admin.MasterCalendar.cssText()}
  .mpc-nav,.mpc-mode{display:none}
  @media print{
    body{background:none}
    .rw-tb{display:none}
    .rw-page{margin:0;max-width:none;box-shadow:none;border:0;padding:0}
    .rw-page th{-webkit-print-color-adjust:exact;print-color-adjust:exact}
    @page{margin:14mm 12mm}
  }
</style></head>
<body>
  <div class="rw-tb"><button onclick="window.close()">닫기</button><button class="p" onclick="window.print()">인쇄</button></div>
  <div class="rw-page">${inner}</div>
</body></html>`;
}

function rpToggleFixed() {
    const fixed = $('#rpConfirm').text().indexOf('해제') >= 0;
    const next = fixed ? '편집중' : '확정';

    $j.Common.Util.swalert(fixed ? '확정을 해제하고 다시 편집하시겠습니까?' : '이 주차를 확정하시겠습니까? 확정 후에는 수정할 수 없습니다.',
        function () {
            $.post('/adm/ajax/project/weekly/status', { num: rpNum, status: next }, function (res) {
                if (!res.result) return $j.Common.Util.swalert(res.message || '상태를 바꾸지 못했습니다.');
                rpLoad();
            });
        }, [next, '취소']);
}
